import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { ContractMode } from 'contexts/contract/interface'
import { LocationsDTO } from 'models'
import { FormFinancingKeys } from './types'

interface Schema {
    id: FormFinancingKeys
}

export const FormFinancingValue = (
    location: LocationsDTO[],
    typeContract: ContractMode | undefined
): {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] => {
    return [
        {
            input: {
                id: 'valorTotalDivida',
                label: 'Valor total da dívida',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15,
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorParcela',
                label: 'Valor da parcela',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'dataLiberacaoCredito',
                label: 'Data Liberação de crédito',
                placeholder: 'dd/mm/aaaa',
                type: 'date',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'ufLiberacaoCredito',
                label: 'UF Liberação de Crédito',
                optionsType: 'uf',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'municipioLiberacaoCredito',
                label: 'Município Liberação de Crédito',
                options: location?.map(({ municipio, codigoTomDetran }) => ({
                    text: municipio,
                    value: `${String(codigoTomDetran)}|${municipio}`
                })),
                isSearching: true,
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'vencimentoPrimeiraParcela',
                label: 'Vencimento 1ª parcela',
                placeholder: 'dd/mm/aaaa',
                type: 'date',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'vencimentoUltimaParcela',
                label: 'Vencimento da última parcela',
                placeholder: 'dd/mm/aaaa',
                type: 'date',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        }
    ]
}
